import { useCancelProcess } from "@/hooks/use-cancel-process";
import { useTextToSpeechProgressContext } from "@/components/pages/text-to-speech/components/providers/text-to-speech-progress-provider";

export const useCancelTextToSpeech = () => {
  const progressContext = useTextToSpeechProgressContext();

  const { cancelProcess, isLoading } = useCancelProcess(
    "/api/text-to-speech/cancel?",
    new URLSearchParams({
      text_to_speech_id: progressContext.processId!,
    }),
    () => progressContext.forceCancelCurrentProcess(),
  );

  return { cancelTextToSpeech: cancelProcess, isCancelling: isLoading };
};
